<template>
    <listSurveysComponent />
</template>

<script>
import listSurveysComponent from "@/views/surveys/pages/list_surveys/components/list_surveys_component.vue"
export default {
    name: "surveysPage",
    components: {
        listSurveysComponent
    },
}
</script>

<style lang="css" scoped>
</style>
